/*
  Scroll reveal — reveals each section as it scrolls into view.

  The hidden state is applied by CSS keyed to .sr-enabled on <html>, which an
  inline script in the loader section sets before any section paints. This file
  only decides WHEN each section flips to .sr-in.
*/
(function () {
  // Only template sections animate. Header, mega-menu, discount banner and
  // footer render outside #MainContent, so scoping here leaves them alone.
  // The loader section itself has no visible output, so skip it too.
  var SELECTOR = '#MainContent .shopify-section:not(.scroll-reveal-section)';

  // Bail on the same conditions as the inline script, so if hiding never
  // happened we also never try to reveal.
  if (!document.documentElement.classList.contains('sr-enabled')) return;

  function reveal(el) {
    el.classList.add('sr-in');

    // transitionend bubbles from the staggered children, so only settle once
    // the section's own transform finishes.
    function onEnd(event) {
      if (event.target !== el || event.propertyName !== 'transform') return;
      el.classList.add('sr-done');
      el.removeEventListener('transitionend', onEnd);
    }
    el.addEventListener('transitionend', onEnd);
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        reveal(entry.target);
        observer.unobserve(entry.target);
      });
    },
    // Shrink the viewport's bottom edge up by 35% so a section only counts as
    // "in view" once it is well inside the screen, not as it peeks in.
    { rootMargin: '0px 0px -35% 0px', threshold: 0 }
  );

  function observe(section, onloadIndex) {
    // Sections already on screen at load animate too, staggered top to bottom
    // so the page builds itself instead of appearing fully formed.
    if (onloadIndex >= 0) {
      setTimeout(function () {
        reveal(section);
      }, 120 + onloadIndex * 180);
      return;
    }
    observer.observe(section);
  }

  function init() {
    var sections = document.querySelectorAll(SELECTOR);
    var onloadCount = 0;

    for (var i = 0; i < sections.length; i++) {
      var visibleAtLoad = sections[i].getBoundingClientRect().top < window.innerHeight;
      observe(sections[i], visibleAtLoad ? onloadCount++ : -1);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor swaps section markup; reveal the replacement node, but only
  // for the template sections we actually animate.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section || !section.closest) return;
    if (!section.classList.contains('shopify-section')) return;
    if (section.classList.contains('scroll-reveal-section')) return;
    if (!section.closest('#MainContent')) return;
    reveal(section);
  });
})();
